import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@verlo/shared/components/ui/sonner";
import { AuthProvider } from "@verlo/shared/contexts/AuthContext";
import { AppProvider } from "@verlo/shared/contexts/AppContext";
import ErrorBoundary from "@verlo/shared/components/common/ErrorBoundary";
import HostGate from "./components/HostGate";
import cloudRoutes from "./routes/cloudRoutes";
import NotFound from '@verlo/shared/components/NotFound';

// cloud-ui — the back office on Fargate (P7, plan §6). The old single tree chose its router by
// the `@surface-routes` webpack alias; a workspace makes the surface the *package*, so the
// back-office route tree (accounts, back office, reports, Bridge — with reports/bridge lazy) is
// simply imported here. `/` and the catch-all land on `/back-office`, not `/tables`, which is
// the one place this tree cannot just be the monolith minus the FOH half.
//
// `HostGate` sits outside the session: on an address with no organisation behind it (#181)
// nothing below it mounts, so there is no login form and no `/auth/me`.
function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <HostGate>
            <AuthProvider>
              <AppProvider>
                <Routes>
                  {cloudRoutes()}
                  <Route path="/" element={<Navigate to="/back-office" replace />} />
                  <Route path="*" element={<NotFound home="/back-office" homeLabel="Back to Today" />} />
                </Routes>
                <Toaster position="bottom-right" />
              </AppProvider>
            </AuthProvider>
          </HostGate>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
